import React, { FC } from "react";
import classNames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import { getGatsbyImage } from "gatsby-plugin-storyblok-image";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { checkFileType, FileType } from "@app/helpers/check-file-type";
import { IconBoxData } from "./types";

export const IconBox: FC<IconBoxData> = ({ icon, title }) => (
  <div
    className={classNames(
      "border-divider rounded-lg border border-solid p-6",
      "lg:min-h-[260px]",
      "xl:min-h-[320px] xl:p-7.5",
      "xxxl:rounded-4xl",
    )}
  >
    <div
      className={classNames(
        "bg-base-300/25 flex h-15 w-15 flex-col items-center justify-center rounded-full",
      )}
    >
      {icon?.filename ? (
        checkFileType(icon?.filename) === FileType.IMAGE ? (
          <GatsbyImage
            image={getGatsbyImage(icon.filename, {
              layout: "fixed",
            })}
            alt={icon.alt ?? "Icon"}
            className="max-w-6"
          />
        ) : (
          <img
            src={icon.filename}
            alt={icon.alt ?? "Icon"}
            className="max-w-6"
          />
        )
      ) : null}
    </div>
    <div
      className={classNames(
        "text-medium text-primary-content mt-8",
        "md:mt-10",
        "lg:text-medium-large lg:mt-12",
        "xxl:mt-15 xxl:text-large",
      )}
    >
      <BlockBody richText={title} />
    </div>
  </div>
);
